module.exports = {
  //注册页面
  register: {
    'account': 'account',
    'password': 'password',
    'confirmpassword': 'confirmpassword',
    'code': 'checkcode',
    'language': 'Please select language'
  },
  brands: {
    nike: 'Nike',
    adi: 'Adidas',
    nb: 'New Banlance',
    ln: 'LI Ning'
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js